import { render, staticRenderFns } from "./Cemetery.vue?vue&type=template&id=55f1df34&scoped=true"
import script from "./Cemetery.vue?vue&type=script&lang=js"
export * from "./Cemetery.vue?vue&type=script&lang=js"
import style0 from "./Cemetery.vue?vue&type=style&index=0&id=55f1df34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f1df34",
  null
  
)

export default component.exports